<template>
  <div>
    <!-- 业务处理 权限-->
    <baseBreadcrumb :page="$t('message.japaneseOffice')" :menu="$t('message.theRoleList')" />
    <div class="body">
      <div class="auth">
        <div class="row" v-for="(item, index) in authList" :key="index">
          <div class="item" v-for="(items, indexs) in item" :key="indexs">
            <el-checkbox v-model="items.checked">{{ items.field_name }}</el-checkbox>
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="btn">
        <el-button type="primary" @click="allChecked">{{ $t('message.allChecked') }}</el-button>
        <el-button type="primary" @click="setAuthField">{{ $t('message.save') }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      authList: [],
      role_id: this.$route.query.role_id
    };
  },
  created() {
    let datas = {
      role_id: this.role_id
    }
    this.$api.JapaneseOffice.getAuthFieldList(datas).then(res => {
      this.authList = res.data

    })
  },
  methods: {
    // 全选
    allChecked() {
      this.authList.forEach(item => {
        item.forEach(items => {
          items.checked = true
        })
      })
    },
    //权限设置 保存
    setAuthField() {
      let datas = {
        role_id: this.role_id,
        auth_filed_ids: []
      }
      this.authList.forEach(item => {
        item.forEach(items => {
          if (items.checked) {
            datas.auth_filed_ids.push(items.id)
          }
        })
      })
      this.$api.JapaneseOffice.setAuthField(datas).then(res => {
        this.$message.success(res.msg)
      })

    },
  }
}
</script>
<style lang='scss' scoped>
.auth {
  .row {
    margin-bottom: 30px;
    display: flex;

    .item {
      margin-right: 35px;
    }
  }
}

.btn {
  // text-align: center;

  .el-button {
    margin-left: 50px;
  }
}
</style>